import type { Styles } from 'common/types';

export const styles: Styles = {
  brandOptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    p: 0,
  },
  brandMainRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 1.5,
    p: '6px 16px',
    transition: 'background-color 0.2s',
  },
  subBrandList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    bgcolor: 'rgba(0, 0, 0, 0.02)',
  },
  subBrandItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '6px 16px 6px 56px',
    transition: 'background-color 0.2s',
    '&:hover': {
      bgcolor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  aosIcon: {
    width: 14,
    height: 14,
    borderRadius: 2,
  },
};
